// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__hqPs4","footer":"ModalCreateQualiphyProcedure_footer__FWJ1u","additionData":"ModalCreateQualiphyProcedure_additionData__1cmZO"};